import React, { useState, useEffect } from "react";
import {
  Box,
  Link,
  Breadcrumbs,
  Stack,
  Button,
  Grid,
  AppBar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Toolbar,
  Typography,
  CircularProgress,
  Snackbar,
  Checkbox,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import {
  externalpostApi,
  externalgetApi,
} from "../../services/external/externalApis";
import { MAPLOCATION_API_01, MAPLOCATION_API_02 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import {
  CON_STATUS_ACTIVE,
  CON_STATUS_DELETED,
  CON_STATUS_PENDING,
} from "../../utils/sys/Constants";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Chip } from "@mui/material";
import currencyFormat from "../../utils/common/CurrencyFormat";
import AddToolbar from "../../components/common/AddToolbar";
function MapLocations() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const location = useLocation();
  const { userRefCode, locCode, username } = location.state || {}; // Destructure the

  console.log("username", username);

  const { ORDERCODE } = location.state || {};
  const [orderData, setOrderData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // New state for snackbar severity
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const SYS_USER = useSelector((state) => state.user) || {};
  const [data, setData] = useState("");
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME, USERREFCODE } =
    SYS_USER.USER_PARAM || {};

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const result = await externalgetApi(MAPLOCATION_API_01, "get", {
        COMPCODE,
        userRefCode,
        USERNAME: username,
        STS: CON_STATUS_ACTIVE, // Fetch only items where STS is 'A'
      });

      if (Array.isArray(result)) {
        const updatedResult = result.map((item) => ({
          ...item,
          isSelected: item.STS === CON_STATUS_ACTIVE ? CON_STATUS_ACTIVE : "", // Set isSelected based on STS
        }));
        setOrderData(updatedResult); // Populate orderData with the updated array
      } else {
        console.error("Unexpected API result format:", result);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };

  const [checkedLocCode, setCheckedLocCode] = useState(locCode || "");
  console.log("locCode", locCode);
  useEffect(() => {
    if (locCode) {
      setCheckedLocCode(locCode);
      console.log("locCode", locCode);
    }
  }, [locCode]);

  const handleLocCodeChange = (event) => {
    setCheckedLocCode(event.target.value);
  };

  const gotToView = () => {
    navigate("/ViewUsers");
  };
  const handleCheckboxChange = (e, index) => {
    if (!orderData || index < 0 || index >= orderData.length) {
      console.error("Invalid index or orderData not initialized");
      console.log("orderData:", orderData, "index:", index);
      return;
    }

    const updatedData = [...orderData];
    updatedData[index].isSelected = e.target.checked ? CON_STATUS_ACTIVE : "";
    setOrderData(updatedData);
  };

  const handleSubmit = async () => {
    try {
      if (!orderData || orderData.length === 0) {
        console.error("No data to submit");
        return;
      }

      const payload = {
        mapLocationUsersDt: orderData
          .filter((item) => item.isSelected === CON_STATUS_ACTIVE) // Include only checked items
          .map((item) => ({
            COMPCODE, // Static value
            loccode: item.LOCCODE, // Dynamic location code
            USERNAME: username, // Static username
            USERREFCODE: String(userRefCode), // Static user reference code
          })),
        reason: "Selection Update",
        COMPCODE, // Static compcode for the overall payload
        USERREFCODE: String(userRefCode), // Static user reference code
        USERNAME: username, // Static username for the overall payload
        enuser: USERNAME, // Static user for the overall payload
        locdate: new Date().toISOString(), // Current date in ISO format
        sts: orderData.some((item) => item.isSelected === CON_STATUS_ACTIVE)
          ? CON_STATUS_ACTIVE
          : "", // Overall 'sts' value
      };

      console.log("Payload for API:", payload);

      const response = await externalpostApi(MAPLOCATION_API_02, payload);

      console.log("API Response:", response);
      setOpenSnackbar(true);
      fetchData();
      // Optionally show success snackbar here
    } catch (error) {
      console.error("Error in API call:", error);
      // Optionally show error snackbar here
    }
  };

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">User</Link>
                <Link underline="none">Map Location</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack
                sx={{
                  ...styles.AI_fixedStack2,
                  direction: "row",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={gotToView}
                  variant="contained"
                  startIcon={<ArrowBackIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box
        sx={{
          ...styles.box_container_add,
          // background: theme.palette.background.paper,
        }}
      >
        {/* <Toolbar
          sx={{
            width: "100%",
            pl: { sm: 2, md: 2 },
            pr: { xs: 1, sm: 1 },
            background: theme.palette.background.paper,
            marginTop: { xs: "170px", md: "155px" },
          }}
        >
          <Typography
            component="div"
            sx={{
              ...theme.typography.h2,
              color: theme.palette.text.primary,
              flex: "1 1 100%",
              ml: 1,
              fontSize: "20px",
              fontWeight: 600,
            }}
          >
            Map Location :{" "}
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                color: theme.palette.text.secondary,
              }}
            >
              {username}
            </span>
          </Typography>
        </Toolbar> */}

        {isLoading ? (
          <CircularProgress sx={{ display: "block", margin: "auto", mt: 5 }} />
        ) : (
          <Grid container spacing={2}>
            {/* First Table */}

            <Grid item xs={12}>
              {" "}
              <Box sx={styles.col_title}>
                <Typography variant="title" align="left">
                  Map Location :{" "}
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: theme.palette.text.secondary,
                    }}
                  >
                    {username}
                  </span>
                </Typography>
              </Box>
            </Grid>

            {/* First Table: Available Location */}
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Box sx={styles.col_title}>
                <Typography variant="title" align="left">
                  Available Location
                </Typography>
              </Box>

              <Box
                sx={{
                  ...styles.cb_col_1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  textAlign: "left",
                  // padding: 2,
                  // marginLeft: 0,
                  // height: "42vh",
                  p: 1,
                  mt: 2,
                  height: {
                    xs: "60vh",
                    sm: "60vh",
                    md: "42vh",
                    lg: "50vh",
                    xl: "50vh",
                  },
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                }}
              >
                <TableContainer
                  sx={
                    {
                      // ...styles.VI_ViewStyledPaper
                      // px: 1,
                    }
                  }
                >
                  <Table
                    // sx={{ minWidth: 250 }}
                    stickyHeader
                    aria-label="order table"
                  >
                    <TableHead>
                      <TableRow
                        sx={{ background: theme.palette.background.paper }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            // background: theme.palette.background.paper,
                          }}
                        >
                          Location
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            // background: theme.palette.background.paper,
                          }}
                          align="center"
                        >
                          Select
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {orderData.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            {item.LOCATION}
                          </TableCell>
                          <TableCell align="center" padding="none">
                            <Checkbox
                              checked={
                                item.isSelected === CON_STATUS_ACTIVE ||
                                item.LOCCODE === locCode
                              } // Both conditions must be true
                              onChange={(e) => handleCheckboxChange(e, index)}
                              inputProps={{
                                "aria-label": `select ${item.LOCATION}`, // Accessibility label
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

            {/* Second Table: Mapped Location */}
            <Grid item xs={12} md={6}>
              <Box sx={styles.col_title}>
                <Typography variant="title" align="left">
                  Mapped Location
                </Typography>
              </Box>
              <Box
                sx={{
                  ...styles.cb_col_1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  textAlign: "left",
                  // padding: 2,
                  // marginLeft: 0,
                  // height: "42vh",
                  p: 1,
                  mt: 2,
                  height: {
                    xs: "60vh",
                    sm: "60vh",
                    md: "42vh",
                    lg: "50vh",
                    xl: "50vh",
                  },
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                }}
              >
                <TableContainer
                  component={Paper}
                  // sx={styles.VI_ViewStyledPaper}
                >
                  <Table
                    stickyHeader
                    sx={{ minWidth: 260 }}
                    aria-label="summary table"
                  >
                    <TableHead>
                      <TableRow
                        sx={{ background: theme.palette.background.paper }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            // background: theme.palette.background.paper,
                          }}
                        >
                          Location
                        </TableCell>
                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            cursor: "pointer",
                            // background: theme.palette.background.paper,
                          }}
                          align="center"
                        >
                          Status
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {orderData.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            {item.LOCATION}
                          </TableCell>
                          <TableCell padding="none" align="center">
                            {item.STS === CON_STATUS_ACTIVE ||
                            item.LOCCODE === locCode ? (
                              <Chip label="Mapped" color="success" />
                            ) : (
                              <Chip label="Not Mapped" color="default" />
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        )}
        <Stack direction="row" spacing={2} justifyContent="flex-end" pt={2}>
          <Button
            variant="contained"
            sx={{
              background: theme.palette.primary.main,
              color: theme.palette.text.buttontxt,
              textTransform: "capitalize",
              width: "120px",
            }}
            onClick={handleSubmit}
          >
            Confirm
          </Button>
        </Stack>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ top: "10%", right: "10%" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          Location Mapped Sucessfully
        </Alert>
      </Snackbar>
    </div>
  );
}

export default MapLocations;
